<template>
  <i
    class="download_center"
    :class="isStore ? 'store_download_center' : ''"
    v-if="show"
    :style="{ top: top }"
    @click="go_index"
  >
    <span v-if="isStore" class="text">
      {{ storeAgentCenterName }}
    </span>
  </i>
</template>

<script>
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

export default {
  name: 'DownloadCenterButton',
  props: {
    show: Boolean,
    top: {
      type: [String, Number],
      default: '4.3rem',
    },
  },
  data() {
    return {}
  },
  computed: {
    // * 当前是否门店系统下的模块
    isStore() {
      return StoreController.isStore(this)
    },
    storeAgentCenterName() {
      return StoreController.storeAgentCenterName()
    },
  },
  methods: {
    go_index() {
      if (this.isStore) {
        StoreController.goStoreIndex()
        return
      }
      const params = {
        zbid: window.zbvd.zbid,
      }
      if (window.zbvd.tpid) {
        params.tpid = window.zbvd.tpid
      }
      const userid = Number(this.$route.query.userid)
      if (!isNaN(userid)) {
        params.userid = this.$route.query.userid
      }
      if (window.userInfo.isAgent || window.userInfo.isAgentAdmin) {
        this.$router.replace({
          name: 'agentTopics',
          query: params,
        })
        return
      }
      this.$router.replace({
        name: 'agentIndex',
        query: params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.download_center {
  position: relative;
  width: 30px;
  height: 98px;
  background: url('~@/assets/images/agent/asideagent.png');
  background-size: 100% 100%;
  cursor: pointer;
  position: fixed;
  top: 322px;
  right: 0;
  z-index: 5;
  &.store_download_center {
    font-style: normal;
    top: 430px;
    border-radius: 0.13rem 0 0 0.13rem;
    background: var(--primary-plain-background-linear-gradient);
    color: #fff;
    writing-mode: vertical-lr;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 0.05rem;
    font-size: 0.13rem;
  }
}
</style>
